module.exports = __webpack_public_path__ + "img/logo-branco.6d4fab1b.png";